import styles from './CaseStudy.module.scss'
import { CaseStudyCard } from './components/CaseStudyCard'

type Props = {
  contents: {
    title: string
    company: string
    image: string
    tags: string[]
    href: string
  }[]
}

export const CaseStudy: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.case_study_container}>
      <div className={styles.main_container}>
        <p className={styles.title}>開発事例</p>
        <div className={styles.case_study_list_container}>
          {contents.map((content) => (
            <CaseStudyCard key={content.title} {...content} />
          ))}
        </div>
      </div>
    </div>
  )
}
